import { FeederInfoDto } from './PDA1120_R01Dto';

function getFeederVal(feeder: FeederInfoDto, kind: 'a' | 'b' | 'c'): string {
  const raw = feeder as unknown as Record<string, unknown>;
  const keys =
    kind === 'a'
      ? ['aFeederCd', 'afeederCd', 'a_feeder_cd']
      : kind === 'b'
        ? ['bFeederCd', 'bfeederCd', 'b_feeder_cd']
        : ['cFeederCd', 'cfeederCd', 'c_feeder_cd'];
  for (const k of keys) {
    const v = raw[k];
    if (v != null && typeof v === 'string') return v.trim();
  }
  return '';
}

export function resolveFeeder(
  feeder: FeederInfoDto,
  workplaceCd: string | null | undefined
): string {
  const wp = (workplaceCd ?? '').trim().toUpperCase();
  const a = getFeederVal(feeder, 'a');
  const b = getFeederVal(feeder, 'b');
  const c = getFeederVal(feeder, 'c');

  if (wp.startsWith('A')) return a;
  if (wp.startsWith('B')) return b;
  if (wp.startsWith('C')) return c;
  return a || b || c;
}
